export const headlinesArr = [
  'Scroll down to learn more about these two fonts. Press the spacebar to generate a new pairing.',
  'Press the spacebar to generate a new pairing. Scroll down to learn more about these two fonts.',
  'Help us improve the pairings by upvoting good pairings. Scroll down to learn more about these two fonts.',
  'Scroll down to learn more about these two fonts. Help us improve the pairings by upvoting good pairings.',
  'Mixfont uses artificial intelligence to create pairings. Help us improve the pairings by upvoting good pairings.',
  'Click the font names in the header to adjust the fonts. Scroll down to learn more about these two fonts.',
  'Get the code for these fonts by clicking "Embed" above. Press the spacebar to generate a new pairing.',
  'Press the spacebar to generate a new pairing. Have feedback or suggestions? Tweet us @mixfont.',
];

export const mobileHeadlinesArr = [
  'Scroll down to learn more about these two fonts.',
  'Scroll down to learn more about these two fonts.',
  'Help us improve the pairings by upvoting good pairings.',
  'Help us improve the pairings by upvoting good pairings.',
  'Mixfont uses artificial intelligence to create pairings.',
  'Click the font names in the header to adjust the fonts.',
  'Get the code for these fonts by clicking "Embed" above.',
  'Have feedback or suggestions? Tweet us @mixfont',
]



// WEBPACK FOOTER //
// ./src/components/generator/constants/Headlines.js